export default "__VITE_ASSET__CtxUmEmK__"